export function isOverflowX(element: HTMLElement) {
  return element.offsetWidth < element.scrollWidth;
}

export function isOverflowY(element: HTMLElement) {
  return element.offsetHeight < element.scrollHeight;
}
